import dt from 'dayjs'
import * as lib from '../lib'
import { IFetchItems, IFetchAffiliate, IAffiliate } from '../types'

export const listAffiliate = async (
	filter: ReturnType<typeof lib.filterSetup>,
	sort: ReturnType<typeof lib.sortSetup>,
	skip: ReturnType<typeof lib.skipSetup>,
	take: ReturnType<typeof lib.takeSetup>,
	signal: AbortSignal,
	token?: string | null
): Promise<IFetchItems<IAffiliate>> => {
	const headers = lib.bearer(token)
	const method: string = 'GET'
	const params: lib.FetchOptions['params'] = {
		f: filter,
		s: sort,
		skip,
		take
	}
	const uri: string = 'affiliate'

	const options: lib.FetchOptions = {
		headers,
		method,
		params,
		signal
	}
	const data = await lib.fetching<IFetchItems<IFetchAffiliate>>(uri, options)

	const rows = data?.items
		?.map((item: IFetchAffiliate): IAffiliate => {
			const { createdAt, updatedAt, deletedAt, ...row } = item
			return {
				...row,
				percents: row.percents?.map(item => ({
					...item,
					at: dt(item.at).toDate(),
					createdAt: dt(item.createdAt).toDate(),
					updatedAt: dt(item.updatedAt).toDate(),
					nextAt: item.nextAt ? dt(item.nextAt).toDate() : null
				})) ?? [],
				createdAt: dt(createdAt).toDate(),
				updatedAt: dt(updatedAt).toDate(),
				deletedAt: deletedAt ? dt(deletedAt).toDate() : null
			}
		})

	return {
		items: rows ?? [],
		total: data?.total ?? 0
	}
}
